import { AxiosResponse } from 'axios';
import { PengajuanPelatihan } from '../../entities/PengajuanPelatihan';
import { ucWords } from '../../app/misc/UcWords';
import { ModulPelatihan, SubModulPelatihan } from '../../entities/Pelatihan';

export class PengajuanPelatihanDataMapper {
  public convertListPengajuanPelatihanDataFromApi(
    result: AxiosResponse<any>
  ): PengajuanPelatihan[] {
    const { data } = result.data;

    let pelatihan: PengajuanPelatihan[] = [];

    data.map((d: any) => {
      return pelatihan.push(
        new PengajuanPelatihan(
          d.id,
          d.uuid,
          d.user_id,
          d.sub_menu_jenis_pelatihan_id,
          d.jenis_pelatihan_id,
          d.path_thumbnail,
          ucWords(d.judul_pelatihan),
          d.jenis_penilaian_id,
          d.waktu_buka_pendaftaran,
          d.waktu_tutup_pendaftaran,
          d.waktu_mulai,
          d.waktu_selesai,
          d.penyelenggara,
          d.informasi_umum,
          d.persyaratan,
          d.angkatan,
          d.kompetensi_teknis,
          d.is_ppkb,
          d.materi_inti,
          d.is_for_guru_madrasah,
          d.status_pengajuan,
          d.alasan ?? '-',
          d.created_at,
          d.updated_at,
          result.data.pagination.total_rows,
          [],
          d.jp,
          d.link_evaluasi ?? '',
          d.logo_penyelenggara ?? ''
        )
      );
    });

    return pelatihan;
  }

  public convertDetailPengajuanPelatihanDataFromApi(
    result: AxiosResponse<any>
  ): PengajuanPelatihan {
    const { data } = result.data;

    let modulPelatihan: ModulPelatihan[] = [];

    let subModulPelatihan: SubModulPelatihan[] = [];

    data.m_modul_pelatihan.map((v: any) => {
      let subModulPelatihanPerModul: SubModulPelatihan[] = [];

      v.m_sub_modul_pelatihan.map((u: any) => {
        subModulPelatihan.push(
          new SubModulPelatihan(
            u.id,
            u.modul_pelatihan_id,
            u.paket_soal_id,
            u.materi_id,
            u.judul,
            u.jenis_ujian,
            u.jenis_sub_modul,
            u.passing_grade,
            u.durasi_latihan,
            u.m_final_project,
            u.m_materi,
            u.m_latihan,
            u.m_paket_soal,
            u?.t_sub_modul_pelatihan_by_user_id !== undefined &&
            u?.t_sub_modul_pelatihan_by_user_id !== null
              ? ucWords(
                  u?.t_sub_modul_pelatihan_by_user_id?.status_pembelajaran
                )
              : '',
            u.ada_latihan,
            u.created_at,
            u.updated_at,
            u.waktu_pengumpulan_final_project,
            u.limit_soal ?? 0,
            u?.t_sub_modul_pelatihan_by_user_id?.has_completed_video ?? false,
            u?.t_sub_modul_pelatihan_by_user_id?.id ?? '',
            u.link_konsultasi,
            u.nama_pemateri_konsultasi,
            u.tanggal_konsultasi
          )
        );

        return subModulPelatihanPerModul.push(
          new SubModulPelatihan(
            u.id,
            u.modul_pelatihan_id,
            u.paket_soal_id,
            u.materi_id,
            u.judul,
            u.jenis_ujian,
            u.jenis_sub_modul,
            u.passing_grade,
            u.durasi_latihan,
            u.m_final_project,
            u.m_materi,
            u.m_latihan,
            u.m_paket_soal,
            u?.t_sub_modul_pelatihan_by_user_id !== undefined &&
            u?.t_sub_modul_pelatihan_by_user_id !== null
              ? ucWords(
                  u?.t_sub_modul_pelatihan_by_user_id?.status_pembelajaran
                )
              : '',
            u.ada_latihan,
            u.created_at,
            u.updated_at,
            u.waktu_pengumpulan_final_project,
            u.limit_soal ?? 0,
            u?.t_sub_modul_pelatihan_by_user_id?.has_completed_video ?? false,
            u?.t_sub_modul_pelatihan_by_user_id?.id ?? '',
            u.link_konsultasi,
            u.nama_pemateri_konsultasi,
            u.tanggal_konsultasi
          )
        );
      });

      return modulPelatihan.push(
        new ModulPelatihan(
          v.id,
          v.pelatihan_id,
          v.judul_modul,
          subModulPelatihanPerModul,
          v.created_at,
          v.updated_at,
          v?.t_modul_pelatihan_by_user_id !== undefined &&
          v?.t_modul_pelatihan_by_user_id !== null
            ? ucWords(v.t_modul_pelatihan_by_user_id.status_pembelajaran)
            : ''
        )
      );
    });

    let pelatihan = new PengajuanPelatihan(
      data.id,
      data.uuid,
      data.user_id,
      data.sub_menu_jenis_pelatihan_id,
      data.jenis_pelatihan_id,
      data.path_thumbnail,
      ucWords(data.judul_pelatihan),
      data.jenis_penilaian_id,
      data.waktu_buka_pendaftaran,
      data.waktu_tutup_pendaftaran,
      data.waktu_mulai,
      data.waktu_selesai,
      data.penyelenggara,
      data.informasi_umum,
      data.persyaratan,
      data.angkatan,
      data.kompetensi_teknis,
      data.is_ppkb,
      data.materi_inti,
      data.is_for_guru_madrasah,
      data.status_pengajuan,
      data.alasan ?? '-',
      data.created_at,
      data.updated_at,
      0,
      modulPelatihan,
      data.jp,
      data.link_evaluasi ?? '',
      data.logo_penyelenggara ?? ''
    );

    return pelatihan;
  }
}
